import React from "react";
import { Building2, Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import EmptyState from "@/components/EmptyState";

/**
 * Wraps page content that REQUIRES a confirmed brand foundation.
 * Renders a global empty state prompting the user to import their website
 * if no brand exists yet.
 *
 * Props:
 *   title, body   - contextual copy for the empty state
 *   children      - actual page content to render when brand is present
 */
export default function RequiresBrand({
  title = "Set up your brand foundation first",
  body = "Import your website URL so Leadmato understands what you sell, who your buyers are, and which keywords to scan for. Takes about 30 seconds.",
  children,
}) {
  const { brand, brandLoading, loading } = useAuth();

  if (loading || brandLoading) {
    return (
      <div className="flex items-center gap-2 text-lm-text2 py-14">
        <Loader2 className="w-4 h-4 animate-spin" /> Loading…
      </div>
    );
  }

  if (!brand) {
    return (
      <EmptyState
        icon={Building2}
        title={title}
        body={body}
        primary={{
          label: "Import my website",
          to: "/onboarding",
          testId: "requires-brand-import-cta",
        }}
        secondary={{
          label: "Learn what happens next",
          to: "/app/brand-foundation",
          testId: "requires-brand-learn-cta",
        }}
        testId="requires-brand-empty"
      />
    );
  }

  return children;
}
